import React from "react";

interface TextToSpeechState {
    showAudioPlayer: boolean;
    isLoading: boolean;
    isAudioPaused: boolean;
    toggleSettingsOpen: () => void;
    pauseTextToSpeech: () => void;
    startTextToSpeech: () => void;
    stopTextToSpeech: () => void;
    resumeTextToSpeech: () => void;
    restartTextToSpeech: () => void;
}

export const TextToSpeechContext = React.createContext<TextToSpeechState>({} as any);

export function useTextToSpeech() {
	return React.useContext(TextToSpeechContext);
}